import { SECURE_KEY } from '../constants';

export const getUserInfo = (payload) => ({
    type: SECURE_KEY.GET_USER_DETAILS,
    payload: {
        payload
    }
})